function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Homem");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Sidebar/-1820",
  transform: "translate(-48.000000, -241.000000)"
}, React.createElement("g", {
  id: "nav",
  transform: "translate(4.000000, 0.000000)"
}, React.createElement("g", {
  id: "Discover",
  transform: "translate(20.000000, 134.000000)"
}, React.createElement("g", {
  id: "Browse",
  transform: "translate(0.000000, 94.000000)"
}, React.createElement("g", {
  id: "Icons/Browse",
  transform: "translate(24.000000, 12.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("path", {
  d: "M3.77779051,1.5 C2.55645975,1.5 1.50611514,1.6907525 0.277801068,2.20074674 C0.108337578,2.26992228 -0.00187372987,2.43673951 0,2.62119344 L0,13.3846751 C0.000267272008,13.5310139 0.0712428908,13.6680312 0.190178533,13.7517653 C0.309114174,13.8354994 0.461052609,13.8554199 0.597244549,13.8051353 C1.8249344,13.3487234 2.64178483,13.1604477 3.77779051,13.1604477 C5.53496188,13.1604477 6.67352733,13.7714474 7.77083402,14.4357919 C7.91183288,14.5214027 8.08816712,14.5214027 8.22916598,14.4357919 C9.32647267,13.7714474 10.4650381,13.1604477 12.2222095,13.1604477 C13.3582152,13.1604477 14.1750656,13.3487234 15.4027555,13.8051353 C15.5389474,13.8554199 15.6908858,13.8354994 15.8098215,13.7517653 C15.9287571,13.6680312 15.9997327,13.5310139 16,13.3846751 L16,2.62119344 C16.0018737,2.43673951 15.8916624,2.26992228 15.7221989,2.20074674 C14.4938849,1.6907525 13.4435402,1.5 12.2222095,1.5 C10.6288743,1.5 9.14342722,2.21901622 8,2.79638181 C6.85657278,2.21901622 5.37112571,1.5 3.77779051,1.5 Z M3.77779051,2.39695475 C5.06960306,2.39695475 6.43898626,3.01623188 7.5555569,3.57420955 L7.5555569,13.28657 C6.56261389,12.7423185 5.37570214,12.2634705 3.77779051,12.2634705 C2.74986006,12.2634705 1.87596358,12.4578652 0.888910336,12.7820358 L0.888910336,2.95054605 C1.89430153,2.56614519 2.7452654,2.39695475 3.77779051,2.39695475 L3.77779051,2.39695475 Z M12.2222095,2.39695475 C13.2547346,2.39695475 14.1056985,2.56614519 15.1110897,2.95054605 L15.1110897,12.7820358 C14.1240364,12.4578652 13.2501399,12.2634705 12.2222095,12.2634705 C10.6242979,12.2634705 9.43738611,12.7423185 8.4444431,13.28657 L8.4444431,3.57420955 C9.56101374,3.01623188 10.9303969,2.39695475 12.2222095,2.39695475 Z",
  id: "Shape",
  stroke: "#1E1F20",
  strokeWidth: 0.5,
  fill: "#1E1F20",
  fillRule: "evenodd",
  mask: "url(#mask-2)"
})))))));

var SvgBrowseleft = function SvgBrowseleft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBrowseleft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/browseleft.dbc51aca.svg";
export { ForwardRef as ReactComponent };